export default "__VITE_ASSET__CVH0nTxO__"